import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";

import "../styles.scss";

export const movieFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <rect
        x="14"
        y="46"
        width="68"
        height="46"
        fill={frameBackgroundColor}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M81.4541 36H82.8995C82.955 36 83.0001 36.0461 83.0001 36.103V101.818C83.0001 101.875 82.955 101.921 82.8995 101.921H82.7075C82.6968 101.966 82.6571 102 82.6096 102H13.1006C13.045 102 13 101.954 13 101.897V91.8205C13 91.8138 13.0006 91.8072 13.0018 91.8009V46.2396C13.0006 46.2332 13 46.2266 13 46.2199V36.1435C13 36.0866 13.045 36.0405 13.1006 36.0405H81.3741C81.3925 36.0159 81.4215 36 81.4541 36ZM15.502 39.5311H16.9103C17.4658 39.5311 17.9162 39.9923 17.9162 40.5612V43.7545C17.9162 44.3234 17.4658 44.7846 16.9103 44.7846H15.502C14.9465 44.7846 14.4961 44.3234 14.4961 43.7545V40.5612C14.4961 39.9923 14.9465 39.5311 15.502 39.5311ZM25.5611 39.5311H24.1529C23.5973 39.5311 23.147 39.9923 23.147 40.5612V43.7545C23.147 44.3234 23.5973 44.7846 24.1529 44.7846H25.5611C26.1167 44.7846 26.567 44.3234 26.567 43.7545V40.5612C26.567 39.9923 26.1167 39.5311 25.5611 39.5311ZM32.8038 39.5311H34.212C34.7676 39.5311 35.2179 39.9923 35.2179 40.5612V43.7545C35.2179 44.3234 34.7676 44.7846 34.212 44.7846H32.8038C32.2482 44.7846 31.7979 44.3234 31.7979 43.7545V40.5612C31.7979 39.9923 32.2482 39.5311 32.8038 39.5311ZM42.8627 39.5311H41.4544C40.8988 39.5311 40.4485 39.9923 40.4485 40.5612V43.7545C40.4485 44.3234 40.8988 44.7846 41.4544 44.7846H42.8627C43.4182 44.7846 43.8686 44.3234 43.8686 43.7545V40.5612C43.8686 39.9923 43.4182 39.5311 42.8627 39.5311ZM50.105 39.5311H51.5133C52.0688 39.5311 52.5192 39.9923 52.5192 40.5612V43.7545C52.5192 44.3234 52.0688 44.7846 51.5133 44.7846H50.105C49.5495 44.7846 49.0991 44.3234 49.0991 43.7545V40.5612C49.0991 39.9923 49.5495 39.5311 50.105 39.5311ZM60.1642 39.5311H58.7559C58.2004 39.5311 57.75 39.9923 57.75 40.5612V43.7545C57.75 44.3234 58.2004 44.7846 58.7559 44.7846H60.1642C60.7197 44.7846 61.1701 44.3234 61.1701 43.7545V40.5612C61.1701 39.9923 60.7197 39.5311 60.1642 39.5311ZM67.4068 39.5311H68.815C69.3706 39.5311 69.8209 39.9923 69.8209 40.5612V43.7545C69.8209 44.3234 69.3706 44.7846 68.815 44.7846H67.4068C66.8512 44.7846 66.4009 44.3234 66.4009 43.7545V40.5612C66.4009 39.9923 66.8512 39.5311 67.4068 39.5311ZM77.4659 39.5311H76.0577C75.5021 39.5311 75.0518 39.9923 75.0518 40.5612V43.7545C75.0518 44.3234 75.5021 44.7846 76.0577 44.7846H77.4659C78.0215 44.7846 78.4718 44.3234 78.4718 43.7545V40.5612C78.4718 39.9923 78.0215 39.5311 77.4659 39.5311ZM15.502 93.3019H16.9103C17.4658 93.3019 17.9162 93.7631 17.9162 94.332V97.5253C17.9162 98.0942 17.4658 98.5554 16.9103 98.5554H15.502C14.9465 98.5554 14.4961 98.0942 14.4961 97.5253V94.332C14.4961 93.7631 14.9465 93.3019 15.502 93.3019ZM25.5611 93.3019H24.1529C23.5973 93.3019 23.147 93.7631 23.147 94.332V97.5253C23.147 98.0942 23.5973 98.5554 24.1529 98.5554H25.5611C26.1167 98.5554 26.567 98.0942 26.567 97.5253V94.332C26.567 93.7631 26.1167 93.3019 25.5611 93.3019ZM32.8038 93.3019H34.212C34.7676 93.3019 35.2179 93.7631 35.2179 94.332V97.5253C35.2179 98.0942 34.7676 98.5554 34.212 98.5554H32.8038C32.2482 98.5554 31.7979 98.0942 31.7979 97.5253V94.332C31.7979 93.7631 32.2482 93.3019 32.8038 93.3019ZM42.8627 93.3019H41.4544C40.8988 93.3019 40.4485 93.7631 40.4485 94.332V97.5253C40.4485 98.0942 40.8988 98.5554 41.4544 98.5554H42.8627C43.4182 98.5554 43.8686 98.0942 43.8686 97.5253V94.332C43.8686 93.7631 43.4182 93.3019 42.8627 93.3019ZM50.105 93.3019H51.5133C52.0688 93.3019 52.5192 93.7631 52.5192 94.332V97.5253C52.5192 98.0942 52.0688 98.5554 51.5133 98.5554H50.105C49.5495 98.5554 49.0991 98.0942 49.0991 97.5253V94.332C49.0991 93.7631 49.5495 93.3019 50.105 93.3019ZM60.1642 93.3019H58.7559C58.2004 93.3019 57.75 93.7631 57.75 94.332V97.5253C57.75 98.0942 58.2004 98.5554 58.7559 98.5554H60.1642C60.7197 98.5554 61.1701 98.0942 61.1701 97.5253V94.332C61.1701 93.7631 60.7197 93.3019 60.1642 93.3019ZM67.4068 93.3019H68.815C69.3706 93.3019 69.8209 93.7631 69.8209 94.332V97.5253C69.8209 98.0942 69.3706 98.5554 68.815 98.5554H67.4068C66.8512 98.5554 66.4009 98.0942 66.4009 97.5253V94.332C66.4009 93.7631 66.8512 93.3019 67.4068 93.3019ZM77.4659 93.3019H76.0577C75.5021 93.3019 75.0518 93.7631 75.0518 94.332V97.5253C75.0518 98.0942 75.5021 98.5554 76.0577 98.5554H77.4659C78.0215 98.5554 78.4718 98.0942 78.4718 97.5253V94.332C78.4718 93.7631 78.0215 93.3019 77.4659 93.3019ZM82 46.1538H14V91.8462H82V46.1538Z"
        fill={frameColor}
        stroke={frameColor}
        stroke-width="0.101268"
        stroke-linecap="round"
      />
      <foreignObject
        width="46%"
        height="43px"
        style={{ borderRadius: "3px" }}
        x="26"
        y="47">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",
            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="15">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
